import React, { ChangeEvent, createRef, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { clearLogo, getCustomizeAsync, getLogoObjFit, saveCustomizeAsync, selectCustomize, selectCustomizedItems, selectLogo, uploadLogoAsync } from './CustomizeSlice'
import { useParams } from 'react-router-dom'
import { MuiColorInput } from 'mui-color-input'
import { Button, ButtonGroup, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import Analysis from '../analysis/Analysis'
import { getSlugsAsync, selectSlugs } from '../slugs/SlugSlice'
import { selectShowCustomizePreview } from '../auth/AuthSlice'

const CustomizeHome = () => {
  const dispatch = useAppDispatch()
  const [sort, setSort] = useState('createdTime,desc')
  const [size, setSize] = useState(50)
  const [page, setPage] = useState(0)
  const { mode } = useParams()
  const customize = useAppSelector(selectCustomize)
  const customizedItems = useAppSelector(selectCustomizedItems)
  const slugs = useAppSelector(selectSlugs)
  const showCustomizePreview = useAppSelector(selectShowCustomizePreview)
  const logo = useAppSelector(selectLogo)
  const [primaryColor, setPrimaryColor] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].primaryColor : customize?.primaryColor ? customize?.primaryColor : '#ffffff')
  const [secondaryColor, setSecondaryColor] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].secondaryColor : customize?.secondaryColor ? customize?.secondaryColor : '#ffffff')
  const [tertiaryColor, setTertiaryColor] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].tertiaryColor : customize?.tertiaryColor ? customize?.tertiaryColor : '#ffffff')
  const [logoB64, setLogoB64] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoB64 : customize?.logoB64 ? customize?.logoB64 : '')
  const [logoUrl, setLogoUrl] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoUrl : customize?.logoUrl ? customize?.logoUrl : '')
  const [logoObjFit, setLogoObjFit] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoObjFit : customize?.logoObjFit ? customize?.logoObjFit : 'fill')
  const [logoWidth, setLogoWidth] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoWidth : customize?.logoWidth ? customize?.logoWidth : 200)
  const [logoHeight, setLogoHeight] = useState(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoHeight : customize?.logoHeight ? customize?.logoHeight : 50)
  const [logoAvailable, setLogoAvailable] = useState((customizedItems?.content?.length && customizedItems?.content?.length >= 1) || logo?.presignedUrl ? true : false)
  const logoFileRef = createRef<HTMLInputElement>()
  const [iFrameRefKey, setiFrameRefKey] = useState(0)

  useEffect(() => {
    dispatch(getCustomizeAsync({ page: { page, size, sort }, mode: mode === 'all' ? 'all' : 'me' }))
    dispatch(getSlugsAsync({ page: { page, size, sort }, mode: 'my', arg: '' }))
  }, [])

  useEffect(() => {
    setPrimaryColor(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].primaryColor : customize?.primaryColor ? customize?.primaryColor : '#ffffff')
    setSecondaryColor(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].secondaryColor : customize?.secondaryColor ? customize?.secondaryColor : '#ffffff')
    setTertiaryColor(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].tertiaryColor : customize?.tertiaryColor ? customize?.tertiaryColor : '#ffffff')
    setLogoB64(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoB64 : customize?.logoB64 ? customize?.logoB64 : '')
    setLogoUrl(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoUrl : customize?.logoUrl ? customize?.logoUrl : '')
    setLogoObjFit(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoObjFit : customize?.logoObjFit ? customize?.logoObjFit : 'fill')
    setLogoWidth(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoWidth : customize?.logoWidth ? customize?.logoWidth : 200)
    setLogoHeight(customizedItems?.content?.length && customizedItems?.content?.length >= 1 ? customizedItems?.content[0].logoHeight : customize?.logoHeight ? customize?.logoHeight : 50)
    setLogoAvailable((customizedItems?.content?.length && customizedItems?.content?.length >= 1) || logo?.presignedUrl ? true : false)
  }, [customizedItems, customize])

  return (<>
    <Grid container spacing={2} sx={{ boxShadow: 2, pb: 5 }}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>Logo</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl sx={{ display: 'block', mb: 4 }}>
          <ButtonGroup variant="contained">
            <Button variant="contained" component="label" disabled={logoAvailable} >
              Upload Logo <input type="file" accept="image/*" hidden ref={logoFileRef} onChangeCapture={(e: ChangeEvent<HTMLInputElement>) => {
                if (e.target.files?.length) {
                  dispatch(uploadLogoAsync(e.target.files[0]))
                  setLogoAvailable(true)
                }
              }} />
            </Button>
            <Button variant="contained" disabled={!logoAvailable} onClick={() => {
              setLogoB64('')
              setLogoUrl('')
              if (logoFileRef.current) { logoFileRef.current.value = '' }
              setLogoAvailable(false)
              dispatch(clearLogo())
            }}>Clear</Button>
          </ButtonGroup>
        </FormControl>
        {logoAvailable && customizedItems?.content?.length && customizedItems?.content?.length >= 1 && customizedItems?.content[0].logoUrl ? <img src={customizedItems?.content[0].logoUrl} alt="logo" style={{ width: logoWidth, marginTop: 5, border: 1, borderColor: '#bbb', borderStyle: 'solid', padding: 1 }} />
          : <></>}
        {logoAvailable && logo?.presignedUrl ? <img src={logo.presignedUrl} alt="logo" style={{ width: logoWidth, marginTop: 5, border: 1, borderColor: '#bbb', borderStyle: 'solid', padding: 1 }} />
          : <></>}
      </Grid>
      {logoB64 && <Grid item xs={12} sm={6}>
        <img src={logoB64} alt="logo" style={{ width: logoWidth, marginTop: 5, border: 1, borderColor: '#bbb', borderStyle: 'solid', padding: 1 }} />
      </Grid>}
      <Grid item xs={12} sm={6}>
        <FormControl sx={{ display: 'block', mb: 4 }}>
          <TextField id="ip-logo-width" label="Logo Width (max 200px)" variant="outlined" value={logoWidth} onChange={(e) => setLogoWidth(Number(e.target.value) > 200 ? 200 : Number(e.target.value))} />
        </FormControl>
      </Grid>
      {/* <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <FormControl sx={{ display: 'block', mb: 4 }}>
              <TextField id="ip-logo-width" label="Logo Width (max 200px)" variant="outlined" value={logoWidth} onChange={(e) => setLogoWidth(Number(e.target.value) > 200 ? 200 : Number(e.target.value))} />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl sx={{ mb: 4 }}>
              <TextField id="ip-logo-height" label="Logo Height (max 200px)" variant="outlined" value={logoHeight} onChange={(e) => setLogoHeight(Number(e.target.value) > 200 ? 200 : Number(e.target.value))} />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl sx={{ mb: 4, minWidth: '200px' }}>
              <InputLabel id="lbl-obj-fit">Logo Object Fit</InputLabel>
              <Select labelId="lbl-obj-fit" id="sel-obj-fit" value={logoObjFit} label="Logo Object Fit"
                onChange={(e) => setLogoObjFit(e.target.value)}>
                <MenuItem value={'fill'}>Fill</MenuItem>
                <MenuItem value={'contain'}>Contain</MenuItem>
                <MenuItem value={'cover'}>Cover</MenuItem>
                <MenuItem value={'none'}>None</MenuItem>
                <MenuItem value={'scale-down'}>ScaleDown</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
    <Grid item xs={12} sx={{ boxShadow: 2, pb: 5, mt: 5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>Colors</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl sx={{ display: 'block', mb: 4 }}>
            <MuiColorInput label="Primary Color" format="hex" value={primaryColor} onChange={(value) => setPrimaryColor(value)} />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl sx={{ display: 'block', mb: 4 }}>
            <MuiColorInput label="Secondary Color" format="hex" value={secondaryColor} onChange={(value) => setSecondaryColor(value)} />
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} sm={4}>
          <FormControl sx={{ display: 'block', mb: 4 }}>
            <MuiColorInput label="Tertiary Color" format="hex" value={tertiaryColor} onChange={(value) => setTertiaryColor(value)} />
          </FormControl>
        </Grid> */}
      </Grid>
    </Grid>
    <Grid container spacing={2} sx={{ pb: 5, mt: 5 }}>
      <Grid item xs={12}>
        <Button variant="contained" onClick={() => {
          dispatch(saveCustomizeAsync({
            ...(customize?.slug && { slug: customize?.slug }),
            ...(customizedItems?.content?.length && customizedItems?.content?.length >= 1 && { slug: customizedItems?.content[0].slug }),
            ...(logo?.filename && { logoS3: logo?.filename }),
            primaryColor, secondaryColor, tertiaryColor, logoB64, logoWidth, logoHeight, logoObjFit
          }))
        }}>Save</Button>
      </Grid>
    </Grid>
    {showCustomizePreview && slugs?.content[0]?.slug && <iframe src={`/analysis/slug/${slugs?.content[0]?.slug}?preview=true&primaryColor=${primaryColor}&secondaryColor=${secondaryColor}&tertiaryColor=${tertiaryColor}&logoB64=${logoB64}&logoWidth=${logoWidth}&logoHeight=${logoHeight}&logoObjFit=${logoObjFit}`}
      key={iFrameRefKey} style={{ width: '100%', height: '100vh', border: 1, borderColor: '#bbb', borderStyle: 'solid' }} title="Preview" />}
  </>)
}

export default CustomizeHome